import React from "react"
import { CoreLoader } from "../components/CoreLoader"

interface LoaderProps {
    status: string;
    enabled: boolean;
}
export const Loader = ({ enabled, status }: LoaderProps) => {

    return (
        enabled &&
        <div className="flex flex-row align-middle items-center pt-4 justify-center">
            <CoreLoader enabled={true} size="48px" className="stroke-green-700" />
            <span className="font-light text-sm justify-self-center p-2 text-gray-600">{status}</span>
        </div>
    )
}